// extracted by mini-css-extract-plugin
module.exports = {"failed":"Gradebook_failed__2vyaR","passed":"Gradebook_passed__1XlWs","attemptResult":"Gradebook_attemptResult__3mwvJ","attemptLink":"Gradebook_attemptLink__3GLai"};